// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_address_country = /** @type {(inputs: {}) => string} */ () => {
	return `Cyprus`
};

const el_address_country = /** @type {(inputs: {}) => string} */ () => {
	return `Κύπρος`
};

const ru_address_country = /** @type {(inputs: {}) => string} */ () => {
	return `Cyprus`
};

const he_address_country = /** @type {(inputs: {}) => string} */ () => {
	return `Cyprus`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const address_country = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.address_country(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("address_country", locale)
	if (locale === "en") return en_address_country(inputs)
	if (locale === "el") return el_address_country(inputs)
	if (locale === "ru") return ru_address_country(inputs)
	if (locale === "he") return he_address_country(inputs)
	return "address_country"
};